import { useState } from "react";
import { BlogPost } from "../../../../typings/blogs";
import BlogCard from "./BlogCard";

const OtherBlogs = ({ slug, blogs }: { slug: string; blogs: BlogPost[] }) => {
  function filterBlogsBySlug(blogs: BlogPost[], slug: string) {
    return blogs.filter((blog: BlogPost) => blog.fields.slug !== slug);
  }
  const [showAll, setShowAll] = useState(false);
  const initiallyShow = 6;

  const otherBlogs = filterBlogsBySlug(blogs, slug);

  return (
    <div className="flex justify-center w-full">
      <div className="flex flex-col gap-4 lg:gap-16 items-start lg:items-center">
        <div className="w-full flex justify-start md:justify-center">
          <h2 className="text-[24px] md:text-[32px] font-bold font-poppins text-[#2D2B4A] text-left md:text-center">
            You might also enjoy reading these
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {otherBlogs &&
            otherBlogs
              .slice(0, showAll ? otherBlogs.length : initiallyShow)
              .map((blog, index) => (
                <div key={index} className="mb-4">
                  <BlogCard blog={blog} />
                </div>
              ))}
        </div>

        {!showAll && blogs.length > 10 && (
          <div
            onClick={() => setShowAll(true)}
            className="flex items-center justify-center w-[10.1rem] h-[3.5rem] border border-[#E1E1E8] rounded-full cursor-pointer transition-colors hover:bg-gray-50"
          >
            <p className="font-bold text-center text-[#666481]">Load more</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtherBlogs;
